import React, {useContext, useState, useEffect} from 'react';
import AbtestItem from "./AbtestItem";
import {CampaignItemContext} from "../../../core/context/context";
import { Checkbox } from "@mui/material";


export default function AbtestsGroup({showAllGroups, rightPanel, showRainbow}) {

    const {types, campaignType, type, items, bundles, onSelectItem, onSelectMultipleItems, selectedList, env} = useContext(CampaignItemContext)

    const [show, setShow] = useState(window.localStorage.getItem("show_group_" + type) == null ? true : window.localStorage.getItem("show_group_" + type) == 'true')

    const handleSetShow = () => {
        setShow(!show)
        window.localStorage.setItem("show_group_" + type, !show)
    }

    useEffect(() => {
        if(showAllGroups === true) {
            setShow(false)
            window.localStorage.setItem("show_group_" + type, false)
        }
        if(showAllGroups === false) {
            setShow(true)
            window.localStorage.setItem("show_group_" + type, true)
        }
    },[showAllGroups])

    const groupSelectedCount = items.filter(item => selectedList?.includes(item.id)).length;
    const isAllGroupSelected = items.length > 0 && groupSelectedCount === items.length;
    const isIndeterminate = groupSelectedCount > 0 && groupSelectedCount < items.length;

    const handleSelectGroup = (e) => {
        e.stopPropagation(); // Не сворачиваем группу
        if (onSelectMultipleItems) {
            const itemsData = items.map(item => ({ item }));
            onSelectMultipleItems(itemsData, !isAllGroupSelected);
        }
    }

    return (
        <>
            <div key={type} className="campaign-group">
                <div className="campaign-type-title" onClick={() => handleSetShow()}>
                    <div className="campaign-item__checkbox" onClick={(e) => e.stopPropagation()} style={{ display: 'inline-flex', alignItems: 'center', marginRight: '8px' }}>
                        {onSelectMultipleItems != undefined && <Checkbox
                            onChange={handleSelectGroup}
                            checked={isAllGroupSelected}
                            indeterminate={isIndeterminate}
                            size="small"
                        />}
                    </div>
                    {type}
                    <span className="campaign-type-title__amount">
                        {items.length}
                    </span>
                </div>

                {show && items.length > 0 && <div className="campaigns-list">
                    {items.map((item) => (
                        <AbtestItem
                            key={env+'_'+item.id}
                            showRainbow={showRainbow}
                            item={item}
                        />
                    ))}
                </div>}
            </div>
        </>
    )

}